import React, { memo, forwardRef } from "react";
const SvgCapitalLambda = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M10.434 24.208a1 1 0 01-.939-1.345L15 7.912a1.393 1.393 0 012.615.001l5.484 14.95a1 1 0 01-.939 1.345h-.087a1 1 0 01-.945-.674L17.088 11.8c-.048-.128-.128-.36-.24-.696a79.26 79.26 0 01-.336-1.032 14.135 14.135 0 00-.24-.84c-.08.32-.168.648-.264.984-.08.32-.168.616-.264.888-.08.272-.152.504-.216.696l-4.11 11.738a1 1 0 01-.943.67h-.041z"
      />
    </svg>
  );
});
SvgCapitalLambda.displayName = "SvgCapitalLambda";
const MemoForwardRef = memo(SvgCapitalLambda);
export default MemoForwardRef;
